import React, { useEffect } from 'react';
import {Observer} from "mobx-react-lite";
import ImageCardSkeletonSkeleton from '../../../../ui_components/Skeletons/ImageCardSkeleton/ImageCardSkeleton';
import SkeletonGrid from '../../../../ui_components/SkeletonGrid/SkeletonGrid';
import { Box } from '@material-ui/core';
import Alignment from '../../../../ui_components/common/enums/Alignment';
import { useI18nContext } from '../../../../contexts/I18nContext';
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShopProductSelectProperties from './ShopProductSelectProperties';
import { useStyles } from './ShopProductSelect.style';
import ShowShopProductDeliveryItem from '../../../Info/ShowShopProductDeliveryItem/ShowShopProductDeliveryItem';
import FilterInput from '../../../Inputs/FilterInput/FilterInput';

const ShopProductSelect: React.FC<ShopProductSelectProperties> = ({
                                                                          store
                                                                      }) => {
    const classes = useStyles();
    const i18n = useI18nContext();

    useEffect(() => {
        store.getProducts();
    }, [store]);

    const onAmountSelect = (productId: string, amount: number) => {
        store.productAmountChange(productId, amount);
    }

    let timeout: NodeJS.Timeout;
    const onFilterChange = (value: string) => {
        clearTimeout(timeout);
        store.productFilter = value;
        const changeFilter = () => {
            store.getProducts();
        };
        timeout = setTimeout(changeFilter, 800);
    }

    const skeletons = [
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>,
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>,
        <ImageCardSkeletonSkeleton></ImageCardSkeletonSkeleton>
    ];

    return (
        <Observer>
            {() => (
                <>
                    <Box className={classes.container}>
                        <Box className={classes.filter_container}
                            justifyContent={Alignment.SPACE_BETWEEN}>
                            <div className={classes.shopping_cart_container}>
                                <div className={classes.shopping_cart_icon_container}><ShoppingCartIcon/></div>
                                {store.selectedProducts && store.selectedProducts.length > 0 && <ul>
                                    {store.selectedProducts.map((selectedProduct, i) => (
                                        <li>
                                            {selectedProduct.name} ({selectedProduct.amount})
                                        </li>
                                    ))}
                                </ul>}
                                {(!store.selectedProducts || store.selectedProducts.length === 0) &&
                                <div className={classes.with_cart_items_text}>Sin productos en el carrito. Seleccione productos en el área a la derecha para adicionarlos al carrito.</div>}
                            </div>
                        </Box>
                        <div className={classes.products_container}>
                            <div className={classes.filter_products_container}>
                                <FilterInput value={store.productFilter}
                                        placeholder={'Buscar productos'}
                                        onChange={onFilterChange}/>
                            </div>
                            <div className={classes.article_container}>
                                {(!store.products || store.products.length === 0) && !store.loadingShopProducts &&
                                    <MessageCard icon={FastfoodIcon} title={i18n.translate("SELECT_A_FILTER_TO_SHOW_ARTICLES")}
                                                subtitle={''}/>}
                                {store.loadingShopProducts && <div><SkeletonGrid skeletons={skeletons}></SkeletonGrid></div>}
                                {!store.loadingShopProducts && store.products &&
                                    <>
                                        

                                        {store.products.map((el, i) => (
                                            <ShowShopProductDeliveryItem
                                                    key={i}
                                                    id={el.id}
                                                    title={el.name}
                                                    text={el.description}
                                                    imageName={el.defaultImage}
                                                    price={el.price}
                                                    stockAmount={el.stockAmount}
                                                    selectedAmount={store.selectedProducts ? store.selectedProducts.find(t => t.id === el.id)?.amount : 0}
                                                    isSelectable={true}
                                                    onAmountSelect={(amount) => onAmountSelect(el.id, amount)}
                                                />
                                            ))
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </Box>
                </>
            )}
        </Observer>
    )
}

export default ShopProductSelect;